import { render } from "./TermandConditions.vue?vue&type=template&id=038d50f9&scoped=true"
import script from "./TermandConditions.vue?vue&type=script&lang=js"
export * from "./TermandConditions.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/hi5admin_demo/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-038d50f9"]])

export default __exports__